import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'
import { getLink } from "../dataProvider/links.js"
import { Helmet } from "react-helmet";
import "../scss/v2/faq.scss"

function FAQ(props) {

    const { t, i18n } = useTranslation();
    const [product, setProduct] = useState({});

    useEffect(() => {
        if (props.products[0] && !product.id) setProduct(props.products[0])
    }, [props.products, product.id])

    function renderQuestions(){
        let i = 1;
        const questionBlock = [];
        while(i <= 11){
            if(i===6 || i === 11){
                questionBlock.push(
                    <div className="faq-element" key={i}>
                        <h2 className="faq-question">{t(`faq.element.${i}.question`)}</h2>
                        <p className="faq-answer">
                            {t(`faq.element.${i}.answer`, { acqPrice: product.acqPrice, subPrice: product.subPrice })}
                            <Link to={getLink(i === 6 ? "pricing" : "contact", i18n.language)}><span className="faq-answer faq-answer-link">{t(`faq.element.${i}.link`)}</span></Link>
                        </p>
                    </div>
                )
            } else if(i===8 || i === 10){
                questionBlock.push(
                    <div className="faq-element" key={i}>
                        <h2 className="faq-question">{t(`faq.element.${i}.question`)}</h2>
                        <p className="faq-answer">
                            {t(`faq.element.${i}.answer`, { acqPrice: product.acqPrice, subPrice: product.subPrice })}
                            <Link to={getLink(i === 10 ? "forgotPassword" : "unsubscribe", i18n.language)}><span className="faq-answer faq-answer-link">{t(`faq.element.${i}.link`)}</span></Link>
                            {t(`faq.element.${i}.end`)}
                        </p>
                    </div>
                )
            } else {
                questionBlock.push(
                    <div className="faq-element" key={i}>
                        <h2 className="faq-question">{t(`faq.element.${i}.question`)}</h2>
                        <p className="faq-answer">{t(`faq.element.${i}.answer`, { acqPrice: product.acqPrice, subPrice: product.subPrice })}</p>
                    </div>
                )
            }
            i++;
        }
        return questionBlock;
    }

    return (
        <div className="faq">
            <Helmet>
                <title>{t("meta.title.faq")}</title>
                <meta name="description" content={t("meta.description.faq")} />
            </Helmet>
            <div className="container">
                <div className="row">
                    <div className="col-12 col-lg-8 offset-lg-2">
                        <h1 className="faq-title">{t('faq.title')}</h1>
                        <div className="faq-separator"></div>
                        {renderQuestions()}
                        <div className="faq-separator bottom-separator"></div>
                    </div>
                </div>
            </div>
        </div>
    )

}

const mapStateToProps = state => ({ products: state.product.products });

export default connect(mapStateToProps, null)(FAQ);